import { connect } from 'react-redux';
import { ApplicationState, WithScope } from '@mews-commander/types';
import { Dialog } from '@optimus-web/core';
import { isOpened, isFetching, getCustomerId } from '../selectors';
import IdentityDocumentScanner from './IdentityDocumentScanner';

interface StateProps {
    loading?: boolean;
    opened?: boolean;
    customerId?: string;
}

type OwnProps = WithScope;

type Props = StateProps & OwnProps;

const IdentityDocumentScannerDialog: React.FC<Props> = ({ loading, opened, ...others }) => (
    <Dialog active={opened} loading={loading}>
        <IdentityDocumentScanner {...others} />
    </Dialog>
);

export default connect<StateProps, {}, OwnProps, ApplicationState>((state, { scope }) => ({
    loading: isFetching(state, { scope }),
    opened: isOpened(state, { scope }),
    customerId: getCustomerId(state, { scope }),
}))(IdentityDocumentScannerDialog);
